/**
 * The profile's "Last seen" copy from the server's hour-floored `lastSeenAt` (ISO or null) — Blockari's
 * `screens/last-seen.ts` (c258375). Coarse on purpose: calendar days in the viewer's time zone, then weeks, then a date.
 * Null (never seen, or an older server that does not send it) shows nothing. There is no "Active now": the data is an hour
 * floor, which cannot honestly say how long ago within that hour.
 */
export function lastSeenLabel(lastSeenAt: string | null | undefined, now: Date = new Date()): string | null {
  if (!lastSeenAt) return null;
  const at = new Date(lastSeenAt);
  if (Number.isNaN(at.getTime())) return null;
  const dayStart = (d: Date): number => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  // Calendar days apart (rounded, so a daylight-saving day of 23 or 25 hours still counts as one).
  const days = Math.round((dayStart(now) - dayStart(at)) / 86_400_000);
  if (days <= 0) return 'Last seen today';
  if (days === 1) return 'Last seen yesterday';
  if (days < 7) return `Last seen ${days} days ago`;
  if (days < 30) {
    const weeks = Math.floor(days / 7);
    return `Last seen ${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
  }
  const date = at.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  return `Last seen ${date}`;
}
